(function() {
  class Gallery {
    constructor (root_element) {
      this._previous_button = root_element.querySelector('.js-gallery-previous');
      this._next_button = root_element.querySelector('.js-gallery-next');
      this._full_screen_view = root_element.querySelector('.c-gallery__fullscreen-view');
      this._full_screen_view_inner = root_element.querySelector('.c-gallery__fullscreen-view__inner');
      this._close_buttons = root_element.querySelectorAll('.js-gallery-close');

      this._active_slide_index = 0;
      this._slides = root_element.querySelectorAll('.c-gallery__slide');
      for (let i = 0; i < this._slides.length; i++) {
        const slide = this._slides[i];
        if (slide.classList.contains('is-active')) {
          this._active_slide_index = i;
          break;
        }
      }

      this._next_button.addEventListener('click', () => this.nextSlide());
      this._previous_button.addEventListener('click', () => this.previousSlide());

      this._full_screen_buttons = [...root_element.querySelectorAll('.js-gallery-fullscreen')];
      for (const button of this._full_screen_buttons) {
        button.addEventListener('click', () => this.activateFullScreen());
      }

      // Close on escape key
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.deactivateFullScreen();
        }
      });

      this._full_screen_view.addEventListener('click', (e) => {
        if (e.target === this._full_screen_view) {
          this.deactivateFullScreen();
        }
      });
      for (const button of this._close_buttons) {
        button.addEventListener('click', e => this.deactivateFullScreen());
      }
    }

    nextSlide() {
      this.setActiveSlide(this._active_slide_index + 1);
    }
    previousSlide() {
      this.setActiveSlide(this._active_slide_index - 1);
    }

    activateFullScreen() {
      while (this._full_screen_view_inner.firstChild) {
        this._full_screen_view_inner.removeChild(this._full_screen_view_inner.firstChild);
      }

      const slide = this._slides[this._active_slide_index];
      const caption = slide.querySelector('figcaption')?.innerHTML;

      this._full_screen_view.classList.add('is-active');

      const figure = document.createElement('figure');
      figure.classList.add('c-gallery__figure');

      const img_src = slide.dataset.fullscreenSrc;
      const img = document.createElement('img');
      img.src = img_src;
      figure.appendChild(img);

      if (caption) {
        const caption_element = document.createElement('figcaption');
        caption_element.innerHTML = caption;
        figure.appendChild(caption_element);
      }

      this._full_screen_view_inner.appendChild(figure);
      document.documentElement.classList.add('js-no-scroll');
    }

    deactivateFullScreen() {
      this._full_screen_view.classList.remove('is-active');
      document.documentElement.classList.remove('js-no-scroll');
    }

    setActiveSlide(index) {
      let active_index = index % this._slides.length;
      if (active_index < 0) {
        active_index = this._slides.length + active_index;
      }

      let previous_index = active_index - 1;
      let next_index = active_index + 1;

      if (previous_index < 0) {
        previous_index = this._slides.length - 1;
      }
      if (next_index >= this._slides.length) {
        next_index = 0;
      }

      // Reset all slides
      for (let i = 0; i < this._slides.length; i++) {
        const slide = this._slides[i];
        slide.classList.remove('is-previous', 'is-next', 'is-active');
      }

      // Set the new states
      this._slides[previous_index].classList.add('is-previous');
      this._slides[next_index].classList.add('is-next');
      this._slides[active_index].classList.add('is-active');
      this._active_slide_index = active_index;
    }
  }

  function main() {
    const galleries = document.querySelectorAll('.c-gallery');
    for (let i = 0; i < galleries.length; i++) {
      new Gallery(galleries[i]);
    }
  }

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main);
  }
})();
